import React, { useState } from "react";
import { Scale, ShieldAlert, Cpu, Headset, Landmark } from "lucide-react";
import { SectionHeading, Reveal } from "../common/Section";
import { track, EVENTS } from "../../lib/analytics";

const ROLES = [
  { id: "compliance", icon: Scale, label: "Compliance / Risk", msg: "Encode your policies, define escalation and human oversight, and produce reviewable evidence for every AI interaction." },
  { id: "security", icon: ShieldAlert, label: "Information Security", msg: "Detect prompt injection, stop sensitive information leaving and control what AI systems and agents are allowed to do." },
  { id: "technology", icon: Cpu, label: "Technology / AI", msg: "A model-agnostic control layer with APIs and flexible deployment that sits in front of any AI system you run." },
  { id: "operations", icon: Headset, label: "Operations / QA", msg: "Screen conversations at scale, prioritise material risks and route the right cases to human reviewers." },
  { id: "board", icon: Landmark, label: "Board / Leadership", msg: "Clear visibility, human accountability and management information showing how AI risk is controlled across the organisation." },
];

export default function BuyerSelector() {
  const [active, setActive] = useState("compliance");
  const sel = ROLES.find((r) => r.id === active);
  const choose = (id) => { setActive(id); track(EVENTS.BUYER_SELECTED, { role: id }); };

  return (
    <section className="border-t border-border py-16 lg:py-24 bg-muted/40">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <SectionHeading eyebrow="Made for your role" title="I am responsible for…" subtitle="norse3 speaks to every stakeholder in an AI governance decision." />
        </Reveal>
        <div className="mt-8 flex flex-wrap gap-2">
          {ROLES.map((r) => {
            const Icon = r.icon; const on = active === r.id;
            return (
              <button key={r.id} onClick={() => choose(r.id)} data-testid={`buyer-${r.id}`}
                className={`inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm transition-colors focus:outline-none focus:ring-2 focus:ring-primary/50 ${on ? "border-primary/30 bg-primary/10 text-foreground" : "border-border bg-card text-muted-foreground hover:text-foreground hover:border-primary/25"}`}>
                <Icon className="h-4 w-4" /> {r.label}
              </button>
            );
          })}
        </div>
        <div className="mt-6 rounded-lg border border-border bg-card p-6 lg:p-8 shadow-sm" data-testid="buyer-message">
          <p className="text-lg text-foreground leading-relaxed max-w-3xl">{sel.msg}</p>
        </div>
      </div>
    </section>
  );
}
